module.exports = __webpack_public_path__ + "static/media/logo_vertical.adc5bf05.png";